import { useState } from 'react';
import { Page, Tabs } from '@shopify/polaris';
import Dashboard from './components/Dashboard';
import TeamMembers from './components/TeamMembers';
import TeamShowcases from './components/TeamShowcases';
import Categories from './components/Categories';
import ImportExport from './components/ImportExport';
import ShowcaseEditor from './components/ShowcaseEditor';

function App() {
  const [selected, setSelected] = useState(0);
  const [editingShowcaseId, setEditingShowcaseId] = useState<string | null>(null);

  const tabs = [
    { id: 'dashboard', content: 'Dashboard' },
    { id: 'team-members', content: 'Team Members' },
    { id: 'team-showcases', content: 'Team Showcases' },
    { id: 'categories', content: 'Categories' },
    { id: 'import-export', content: 'Import / Export' },
  ];

  if (editingShowcaseId) {
    return (
      <ShowcaseEditor
        showcaseId={editingShowcaseId}
        onBack={() => setEditingShowcaseId(null)}
        onSave={() => setEditingShowcaseId(null)}
      />
    );
  }

  const renderContent = () => {
    switch (selected) {
      case 0: return <Dashboard />;
      case 1: return <TeamMembers />;
      case 2: return <TeamShowcases onEditDesign={(id) => setEditingShowcaseId(id)} />;
      case 3: return <Categories />;
      case 4: return <ImportExport />;
      default: return <Dashboard />;
    }
  };

  return (
    <Page title="TS Team Showcase">
      <Tabs tabs={tabs} selected={selected} onSelect={setSelected}>
        {renderContent()}
      </Tabs>
    </Page>
  );
}

export default App;
